// extracted by mini-css-extract-plugin
export default {"transmitter":"useTransmitter_transmitter__eykLq"};